import { render, staticRenderFns } from "./email-templates.vue?vue&type=template&id=4e6c0abb&scoped=true"
import script from "./email-templates.vue?vue&type=script&lang=js"
export * from "./email-templates.vue?vue&type=script&lang=js"
import style0 from "./email-templates.vue?vue&type=style&index=0&id=4e6c0abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c0abb",
  null
  
)

export default component.exports